export default "__VITE_ASSET__B2oiwXqx__"